module.exports = __webpack_public_path__ + "static/img/robot.b5bfc198.png";